<template>
  <div class="shortcuts">
    <h4>{{ _.shortcuts }}</h4>
    <ul>
      <li v-for="(sval, skey) in active_shortcuts" :key="skey">
        <router-link :to="sval.path">
          {{ _[sval.label] }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shortcuts: [
        { area: 'sessions', label: 'add_session', path: '/session/create' },
        { area: 'presentations', label: 'add_presentation', path: '/presentation/create' },
        { area: 'persons', label: 'add_person', path: '/person/create' },
      ]
    }
  },
  computed: {
    active_shortcuts() {
      return this.shortcuts.filter(link => this.authorized[link.area].create);
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.shortcuts {
  // border-bottom: 1px solid lighten($primary-color, 80%);
  ul {
    margin: 0 12px 12px 12px;
    li {
      list-style: none;
      a {
        color: lighten($primary-color, 60%);
        text-decoration: none;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
</style>